function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.657 3.059A.6.6 0 003.8 3.6v8.116a.6.6 0 00.879.531l8.116-4.26a.6.6 0 00-.022-1.074L4.657 3.059z",
  fill: "#343434"
});

var SvgIconRun = function SvgIconRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjY1NzI0IDMuMDU4NzZDNC4yNTkxMiAyLjg2OTY2IDMuNzk5OCAzLjE1OTk4IDMuNzk5OCAzLjYwMDczVjExLjcxNjlDMy43OTk4IDEyLjE2ODEgNC4yNzkxOCAxMi40NTc5IDQuNjc4NzEgMTIuMjQ4MkwxMi43OTQ5IDcuOTg3MTZDMTMuMjMyNyA3Ljc1NzI4IDEzLjIyMDEgNy4xMjYxMyAxMi43NzM0IDYuOTEzOTVMNC42NTcyNCAzLjA1ODc2WiIgZmlsbD0iIzM0MzQzNCIvPgo8L3N2Zz4K";
export { SvgIconRun as ReactComponent };